import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Route, Routes} from "react-router-dom";

import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './assets/scss/style.scss'
import './assets/scss/bootstrap.scss'
import './assets/css/materialdesignicons.min.css'

import Index from "./pages/index";
import AdminDashboard from "./pages/admin-dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
// eslint-disable-next-line no-unused-vars
import DoctorDashBoard from "./pages/dashboard/doctor-dashboard";
// eslint-disable-next-line no-unused-vars
import DoctorAppointment from "./pages/dashboard/doctor-appointment";
// eslint-disable-next-line no-unused-vars
import DoctorSchedule from "./pages/dashboard/doctor-schedule";
// eslint-disable-next-line no-unused-vars
import Invoice from "./pages/dashboard/invoices";
// eslint-disable-next-line no-unused-vars
import DoctorMessages from "./pages/dashboard/doctor-messages";
// eslint-disable-next-line no-unused-vars
import DoctorProfile from "./pages/dashboard/doctor-profile";
// eslint-disable-next-line no-unused-vars
import DoctorProfileSettimg from "./pages/dashboard/doctor-profile-setting";
// eslint-disable-next-line no-unused-vars
import PatientList from "./pages/dashboard/patient-list";
// eslint-disable-next-line no-unused-vars
import PatientReview from "./pages/dashboard/patient-review";
// eslint-disable-next-line no-unused-vars
import DoctorChat from "./pages/dashboard/doctor-chat";
// eslint-disable-next-line no-unused-vars
import DoctorTeamOne from "./pages/doctor/doctor-team-one";
// eslint-disable-next-line no-unused-vars
import DoctorTeamTwo from "./pages/doctor/doctor-team-two";
// eslint-disable-next-line no-unused-vars
import DoctorTeamThree from "./pages/doctor/doctor-team-three";
// eslint-disable-next-line no-unused-vars
import PatientDashboard from "./pages/patient/patient-dashboard";
// eslint-disable-next-line no-unused-vars
import PatientProfile from "./pages/patient/patient-profile";
// eslint-disable-next-line no-unused-vars
import BookingAppointment from "./pages/patient/booking-appointment";
// eslint-disable-next-line no-unused-vars
import PatientInvoice from "./pages/patient/patient-invoice";
// eslint-disable-next-line no-unused-vars
import Pharmacy from "./pages/pharmacy/pharmacy";
// eslint-disable-next-line no-unused-vars
import PharmacyShop from "./pages/pharmacy/pharmacy-shop";
// eslint-disable-next-line no-unused-vars
import PharmacyProductDetail from "./pages/pharmacy/pharmacy-product-detail";
// eslint-disable-next-line no-unused-vars
import ShopCart from "./pages/pharmacy/pharmacy-shop-cart";
// eslint-disable-next-line no-unused-vars
import CheckOut from "./pages/pharmacy/pharmacy-checkout";
// eslint-disable-next-line no-unused-vars
import PharmacyAccount from "./pages/pharmacy/pharmacy-account";
import AboutUs from "./pages/aboutus";
// eslint-disable-next-line no-unused-vars
import Departments from "./pages/departments";
// eslint-disable-next-line no-unused-vars
import Faqs from "./pages/faqs";
// eslint-disable-next-line no-unused-vars
import Blogs from "./pages/blogs";
// eslint-disable-next-line no-unused-vars
import BlogDetail from "./pages/blog-detail";
// eslint-disable-next-line no-unused-vars
import Terms from "./pages/terms";
// eslint-disable-next-line no-unused-vars
import Privacy from "./pages/privacy";
import Error from "./pages/error";
import Contact from "./pages/contact";
import Login from "./pages/login";
// import Signup from "./pages/signup";
// import ForgotPassword from "./pages/forgot-password";
// eslint-disable-next-line no-unused-vars
// import EnquiyForm from "./pages/patient/enquire-form"; 


function App() {
  const location = useLocation();

  useEffect(() => {
    AOS.init({ duration: 1000, offset: 80 });
  }, []);

  // refresh AOS on route change so animations trigger when navigating SPA
  useEffect(() => {
    AOS.refresh();
  }, [location.pathname]);
  return (
    <Routes>
      <Route path="/" element={<Index/>}/>
      <Route path="/index" element={<Index/>}/>
      <Route path="/dashboard" element={
        <ProtectedRoute allowedRoles={["admin"]}>
          <AdminDashboard/>
        </ProtectedRoute>
      }/>
      {/* <Route path="/doctor-dashboard" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <DoctorDashBoard/>
        </ProtectedRoute>
      }/>
      <Route path="/doctor-appointment" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <DoctorAppointment/>
        </ProtectedRoute>
      }/>
      <Route path="/doctor-schedule" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <DoctorSchedule/>
        </ProtectedRoute>
      }/>
      <Route path="/invoices" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <Invoice/>
        </ProtectedRoute>
      }/>
      <Route path="/doctor-messages" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <DoctorMessages/>
        </ProtectedRoute>
      }/>
      <Route path="/doctor-profile" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <DoctorProfile/>
        </ProtectedRoute>
      }/>
      <Route path="/doctor-profile-setting" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <DoctorProfileSettimg/>
        </ProtectedRoute>
      }/>
      <Route path="/patient-list" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <PatientList/>
        </ProtectedRoute>
      }/>
      <Route path="/patient-review" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <PatientReview/>
        </ProtectedRoute>
      }/>
      <Route path="/doctor-chat" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <DoctorChat/>
        </ProtectedRoute>
      }/>
      <Route path="/doctor-team-one" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <DoctorTeamOne/>
        </ProtectedRoute>
      }/>
      <Route path="/doctor-team-two" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <DoctorTeamTwo/>
        </ProtectedRoute>
      }/>
      <Route path="/doctor-team-three" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <DoctorTeamThree/>
        </ProtectedRoute>
      }/>
      <Route path="/patient-dashboard" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <PatientDashboard/>
        </ProtectedRoute>
      }/>
      <Route path="/patient-profile" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <PatientProfile/>
        </ProtectedRoute>
      }/>
      <Route path="/booking-appointment" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <EnquiyForm/>
        </ProtectedRoute>
      }/>
      <Route path="/patient-invoice" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <PatientInvoice/>
        </ProtectedRoute>
      }/>
      <Route path="/pharmacy" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <Pharmacy/>
        </ProtectedRoute>
      }/>
      <Route path="/pharmacy-shop" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <PharmacyShop/>
        </ProtectedRoute>
      }/>
      <Route path="/pharmacy-product-detail" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <PharmacyProductDetail/>
        </ProtectedRoute>
      }/>
      <Route path="/pharmacy-product-detail/:id" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <PharmacyProductDetail/>
        </ProtectedRoute>
      }/>
      <Route path="/pharmacy-shop-cart" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <ShopCart/>
        </ProtectedRoute>
      }/>
      <Route path="/pharmacy-checkout" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <CheckOut/>
        </ProtectedRoute>
      }/>
      <Route path="/pharmacy-account" element={
        <ProtectedRoute allowedRoles={["doctor", "admin"]}>
          <PharmacyAccount/>
        </ProtectedRoute>
      }/> */}
      <Route path="/aboutus" element={<AboutUs/>}/>
      <Route path="/privacy" element={<Privacy/>}/>
      <Route path="/faqs" element={<Faqs/>}/>
      <Route path="/blogs" element={<Blogs/>}/>
      <Route path="/blog-detail" element={<BlogDetail/>}/>
      <Route path="/blog-detail/:id" element={<BlogDetail/>}/>
      <Route path="/error" element={<Error/>}/>
      <Route path="*" element={<Error/>}/>
      <Route path="/contact" element={<Contact/>}/>
      <Route path="/login" element={<Login/>}/>
      {/* <Route path="/signup" element={<Signup/>}/>
      <Route path="/forgot-password" element={<ForgotPassword/>}/> */}
    </Routes>
  );
}

export default App;
